import * as React from "react";
import PropTypes from "prop-types";

import "./style.css";
import { _ } from "../../model/utils";

const Title = ({ stringKey }) => <h2 styleName="title-key">{_[stringKey]}</h2>;

Title.propTypes = {
  stringKey: PropTypes.string.isRequired
};

export default Title;
